import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    modalContainer: {
        paddingLeft: '16px',
        paddingRight: '16px',
    },
    modalSizeSmall: {
        minWidth: '100%',
        [theme.breakpoints.up('sm')]: {
            minWidth: '500px',
        },
    },
    modalSizeMedium: {
        [theme.breakpoints.up('md')]: {
            minWidth: '900px',
        },
    },
    modalButtonUi: {
        paddingTop: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            flexWrap: 'wrap',
        },
    },
    customButton: {
        width: '100%',
        marginBottom: '1rem',
        marginLeft: '40%',
        [theme.breakpoints.up('sm')]: {
            width: 'auto',
            marginBottom: '0',
            marginLeft: '0',
        },
    },
}))

export const Modal = ({
    title,
    cancelText,
    cancelMethod,
    okText,
    okMethod,
    openModal,
    extraMethod,
    extraText,
    backMethod,
    backText,
    children,
    okWillClose,
    isOkDisabled,
    modalSize,
    cancelButtonVariant,
    cancelButtonColor,
    backButtonColor,
    backButtonVariant,
    okButtonColor,
    okButtonVariant,
    extraButtonColor,
    extraButtonVariant,
    customButtonText,
    customButtonMethod,
    customButtonColor,
    customButtonVariant,
    hideCustomButton,
    maxWidth,
    fullWidth,
    height,
    titleColour,
    isOpen = true,
    showClose = true,
}) => {
    const classes = useStyles()

    const handleCancelClose = () => {
        if (cancelMethod) {
            cancelMethod()
        }

        openModal(false)
    }

    const handleOkClose = () => {
        if (okWillClose != null) {
            if (okWillClose) {
                openModal(false)
            }
        } else {
            openModal(false)
        }

        if (okMethod) {
            okMethod()
        }
    }

    const handleExtraClose = () => {
        if (extraMethod) {
            extraMethod()
        }

        openModal(false)
    }

    const handleBackClose = () => {
        if (backMethod) {
            backMethod()
        }
    }

    let modalSizeClassName = () => {
        if (modalSize) {
            if (modalSize.toLowerCase() === 'small') {
                return classes.modalSizeSmall
            }
            if (modalSize.toLowerCase() === 'medium') {
                return classes.modalSizeMedium
            }
        }
    }

    const DialogTitle = ({ onClose }) => (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography
                variant='h6'
                color={titleColour ? titleColour : 'primary'}>
                {title}
            </Typography>
            {showClose && (
                <IconButton
                    aria-label='close'
                    className={classes.closeButton}
                    onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            )}
        </MuiDialogTitle>
    )

    return (
        <Dialog
            open={isOpen}
            aria-labelledby='modal'
            maxWidth={maxWidth || false}
            fullWidth={fullWidth || false}
            classes={{
                container: classes.modalContainer,
                paper: modalSizeClassName(),
            }}
            PaperProps={{
                style: {
                    height: height ? height : '',
                    maxWidth: '',
                    margin: 0,
                },
            }}>
            <DialogTitle id='modal-title' onClose={handleCancelClose} />
            <DialogContent>{children}</DialogContent>
            <DialogActions className={classes.modalButtonUi} id='modal-actions'>
                {customButtonText && hideCustomButton !== true && (
                    <Button
                        className={classes.customButton}
                        onClick={customButtonMethod}
                        color={
                            customButtonColor ? customButtonColor : 'default'
                        }
                        variant={
                            customButtonVariant
                                ? customButtonVariant
                                : 'outlined'
                        }>
                        {customButtonText}
                    </Button>
                )}

                {cancelText && (
                    <Button
                        onClick={handleCancelClose}
                        color={
                            cancelButtonColor ? cancelButtonColor : 'default'
                        }
                        variant={
                            cancelButtonVariant
                                ? cancelButtonVariant
                                : 'outlined'
                        }>
                        {cancelText}
                    </Button>
                )}
                {backText && (
                    <Button
                        onClick={handleBackClose}
                        color={backButtonColor ? backButtonColor : 'default'}
                        variant={
                            backButtonVariant ? backButtonVariant : 'outlined'
                        }>
                        {backText}
                    </Button>
                )}
                <Button
                    onClick={handleOkClose}
                    disabled={isOkDisabled}
                    color={okButtonColor ? okButtonColor : 'primary'}
                    variant={okButtonVariant ? okButtonVariant : 'contained'}>
                    {okText}
                </Button>
                {extraText && (
                    <Button
                        onClick={handleExtraClose}
                        color={extraButtonColor ? extraButtonColor : 'default'}
                        variant={
                            extraButtonVariant ? extraButtonVariant : 'outlined'
                        }>
                        {extraText}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}
